var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUndrawWebDesignShowcase6T2L(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 636.807,
    height: 799.969,
    viewBox: "0 0 636.807 799.969",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-793.193 -266.861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.019,577.573l-21.966,1.464,2.929-229.909h54.182Z",
    transform: "translate(758.499 429.01)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.019,577.573l-21.966,1.464,2.929-229.909,35.043.009Z",
    transform: "translate(791.935 429.01)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.462,769.017c-22.993,10.486-44.605,9.952-65.177,1.114l-10.971-263.24L505.89,767.826c-22.977,5.685-27.914,11.5-51.332,7.026,5.393-39.089,10.131-282.891,8.072-326.537l153.761-7.322Z",
    transform: "translate(369.922 212.672)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.433,745.642h0a22.216,22.216,0,0,1-22.178-23.529l2.119-35.807c8.533-15.3,18.891-15.361,30.962-1.106l10.219,31.337a22.217,22.217,0,0,1-21.122,29.1Z",
    transform: "translate(371.156 321.187)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.433,745.642h0a22.216,22.216,0,0,1-22.178-23.529l2.119-35.807c8.533-15.3,18.891-15.361,30.962-1.106l10.219,31.337a22.217,22.217,0,0,1-21.122,29.1Z",
    transform: "translate(404.128 321.187)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.467,
    cy: 42.467,
    r: 42.467,
    transform: "translate(882.341 284.637)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.9,294.82,475.07,267c16.471-8.074,27.655-23.078,36.61-41h30.752C540.965,253.345,539.784,280.052,543.9,294.82Z",
    transform: "translate(379.447 112.828)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.233,539.478l-164.012,4.393c2-78.754-1.507-159.789-9.729-242.78a42.653,42.653,0,0,1,27.483-44.126l15.927-5.973,64.433,17.573,30.409,23.314a31.129,31.129,0,0,1,12.073,26.869C595.213,385.981,605.493,460.822,623.233,539.478Z",
    transform: "translate(367.473 124.438)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.4,502.743h0a17.078,17.078,0,0,1-17.962-15.164l-3.625-32.644,19.375-5.4,16,27.591A17.078,17.078,0,0,1,587.4,502.743Z",
    transform: "translate(421.589 216.639)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.754,537.655l-38.074,1.464L548.392,421.968,541.07,276.993h0a30.4,30.4,0,0,1,26.392,26.355l13.146,103.976Z",
    transform: "translate(410.097 136.512)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.017,129.628l-1.464,96.65,64.433,108.365L88.875,223.349Z",
    transform: "translate(761.982 327.077)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.277,229.313l38.19,65.627-13.534-.732Z",
    transform: "translate(756.281 373.369)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.2,190.489l.472,7.081-3.646-9.723a56.6,56.6,0,0,0-31.461-10.788h0a41.712,41.712,0,0,0-44.374,52.492l.507,6.084,11.715-16.108h0a41.185,41.185,0,0,1,39.648-8.893,69.879,69.879,0,0,1,14.67,6.392,80.61,80.61,0,0,1,18.9,15.68l1.018-6.92C587.49,212.919,583.419,199.858,573.2,190.489Z",
    transform: "translate(387.643 90.008)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(850.021 684.417)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 580,
    height: 350,
    rx: 16,
    transform: "translate(-0.021 0.27)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 568,
    height: 340,
    rx: 15,
    transform: "translate(5.979 4.27)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.85 28.572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M634.733,505.6a2.829,2.829,0,0,0,2.05-4.9l-.194-.771.077-.185a7.6,7.6,0,0,1,14.012.052c2.292,5.52,5.209,11.049,5.928,16.885a22.472,22.472,0,0,1-.394,7.729,90.094,90.094,0,0,0,8.2-37.42,86.965,86.965,0,0,0-.539-9.7q-.447-3.961-1.24-7.866a91.143,91.143,0,0,0-18.074-38.628,24.254,24.254,0,0,1-10.088-10.466,18.5,18.5,0,0,1-1.683-5.056c.491.064,1.852-7.415,1.481-7.874.684-1.039,1.909-1.555,2.657-2.568,3.717-5.04,8.839-4.16,11.513,2.689,5.712,2.883,5.767,7.663,2.262,12.261-2.23,2.925-2.536,6.883-4.492,10.015.2.258.411.507.612.765a91.734,91.734,0,0,1,9.574,15.168,38.135,38.135,0,0,1,2.276-17.712c2.179-5.257,6.263-9.684,9.86-14.228,4.32-5.459,13.179-3.076,13.94,3.843q.011.1.022.2-.8.452-1.569.96a3.837,3.837,0,0,0,1.547,6.982l.078.012a38.183,38.183,0,0,1-1.006,5.708c4.614,17.844-5.347,24.343-19.571,24.635-.314.161-.62.322-.934.475a93.63,93.63,0,0,1,5.04,23.718,88.8,88.8,0,0,1-.065,14.339l.024-.169a23.466,23.466,0,0,1,8.011-13.549c6.165-5.064,14.874-6.929,21.524-11a4.4,4.4,0,0,1,6.745,4.284q-.013.089-.027.178a25.773,25.773,0,0,0-2.89,1.393q-.8.452-1.569.96a3.837,3.837,0,0,0,1.547,6.982l.078.012.161.024a38.209,38.209,0,0,1-7.028,11.005c-2.885,15.577-15.277,17.055-28.532,12.519h-.008a93.608,93.608,0,0,1-6.288,18.356H635.3c-.081-.249-.153-.507-.225-.757a25.512,25.512,0,0,0,6.215-.37c-1.666-2.045-3.333-4.106-5-6.151a1.409,1.409,0,0,1-.1-.121c-.845-1.047-1.7-2.085-2.544-3.132h0a37.38,37.38,0,0,1,1.1-9.523Z",
    transform: "translate(-188.619 -209.68)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.712,202.689H196.652a.881.881,0,1,1,0-1.761h499.06a.881.881,0,1,1,0,1.761Z",
    transform: "translate(-195.771 -161.028)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.214,339.084H310.384a9.109,9.109,0,0,0,0,18.218h294.83a9.109,9.109,0,1,0,0-18.218Z",
    transform: "translate(-208.369 -177.524)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.8,281.084H431.384a9.109,9.109,0,1,0,0,18.218H522.8a9.109,9.109,0,0,0,0-18.218Z",
    transform: "translate(-222.817 -170.599)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.447,
    cy: 7.613,
    rx: 7.447,
    ry: 7.613,
    transform: "translate(18.403)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.447,
    cy: 7.613,
    rx: 7.447,
    ry: 7.613,
    transform: "translate(44.128)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.447,
    cy: 7.613,
    rx: 7.447,
    ry: 7.613,
    transform: "translate(69.854)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.064,169.463a.878.878,0,0,1-.629-.265l-5.025-5.137a.88.88,0,0,1,0-1.231l5.025-5.136a.881.881,0,1,1,1.259,1.231l-4.422,4.52,4.422,4.521a.881.881,0,0,1-.63,1.5Z",
    transform: "translate(-209.43 -155.834)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.334,169.463a.881.881,0,0,1-.629-1.5l4.422-4.521-4.422-4.52a.881.881,0,1,1,1.259-1.231l5.024,5.136a.88.88,0,0,1,0,1.231l-5.024,5.136A.878.878,0,0,1,326.334,169.463Z",
    transform: "translate(-211.256 -155.834)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.435,156.618h-9.343a1.928,1.928,0,0,0-1.928,1.928V167.9a1.928,1.928,0,0,0,1.928,1.929h9.343a1.936,1.936,0,0,0,1.937-1.928v-9.352a1.936,1.936,0,0,0-1.937-1.929Z",
    transform: "translate(-255.999 -155.737)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.435,156.618h-9.343a1.928,1.928,0,0,0-1.928,1.928V167.9a1.928,1.928,0,0,0,1.929,1.929h9.343a1.936,1.936,0,0,0,1.937-1.928v-9.352a1.936,1.936,0,0,0-1.937-1.929Z",
    transform: "translate(-252.894 -155.737)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.935,157.118h-9.343a1.928,1.928,0,0,0-1.928,1.929V168.4a1.928,1.928,0,0,0,1.929,1.928h9.343a1.935,1.935,0,0,0,1.937-1.928v-9.352a1.935,1.935,0,0,0-1.937-1.929Z",
    transform: "translate(-258.924 -155.796)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.1,161.158H437.413a2.351,2.351,0,1,0,0,4.7H512.1a2.351,2.351,0,1,0,0-4.7Z",
    transform: "translate(-224.344 -156.279)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.462,414.928h-73.97a13.649,13.649,0,1,0,0,27.3h73.97a13.649,13.649,0,0,0,0-27.3Z",
    transform: "translate(-215.482 -186.58)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.461,414.928h-73.97a13.649,13.649,0,0,0,0,27.3h73.97a13.649,13.649,0,0,0,0-27.3Z",
    transform: "translate(-232.318 -186.58)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.342,442.987h-73.97a14.53,14.53,0,1,1,0-29.06h73.97a14.53,14.53,0,1,1,0,29.06Zm-73.97-27.3a12.769,12.769,0,1,0,0,25.537h73.97a12.769,12.769,0,1,0,0-25.537Z",
    transform: "translate(-232.199 -186.461)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.76,385.372A60.985,60.985,0,0,1,254.747,370.5a60.145,60.145,0,0,1,51.688,22.6c1.041,1.321-.816,3.2-1.868,1.868a58.28,58.28,0,0,0-29.145-19.735,57.515,57.515,0,0,0-53.794,12c-1.272,1.119-3.147-.742-1.868-1.868Z",
    transform: "translate(-198.585 -181.255)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.448,384.186l7.787,21.3a1.328,1.328,0,0,1-1.274,1.672l-24.912-1.775c-1.686-.12-1.7-2.763,0-2.642l24.912,1.776-1.274,1.672-7.787-21.3C328.315,383.29,330.867,382.6,331.448,384.186Z",
    transform: "translate(-209.623 -182.802)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.656,475.235a2,2,0,0,1-1.452-3.471l.137-.546-.055-.131a5.378,5.378,0,0,0-9.92.037c-1.623,3.908-3.688,7.822-4.2,11.954a15.9,15.9,0,0,0,.279,5.472,63.786,63.786,0,0,1-5.8-26.492,61.57,61.57,0,0,1,.382-6.868q.316-2.8.878-5.569a64.526,64.526,0,0,1,12.8-27.347,17.171,17.171,0,0,0,7.142-7.41,13.094,13.094,0,0,0,1.191-3.579c-.348.046-1.311-5.25-1.049-5.574-.484-.735-1.352-1.1-1.881-1.818-2.632-3.568-6.258-2.945-8.151,1.9-4.044,2.041-4.083,5.426-1.6,8.681,1.579,2.071,1.8,4.873,3.181,7.091-.143.182-.291.359-.433.542a64.947,64.947,0,0,0-6.778,10.738,27,27,0,0,0-1.612-12.54c-1.543-3.722-4.434-6.856-6.981-10.073a5.541,5.541,0,0,0-9.87,2.721c-.005.047-.01.095-.015.142q.567.32,1.111.679a2.716,2.716,0,0,1-1.1,4.943l-.055.008a27.026,27.026,0,0,0,.713,4.041C644.252,435.4,651.3,440,661.375,440.21c.222.114.439.228.661.336a66.285,66.285,0,0,0-3.568,16.792,62.858,62.858,0,0,0,.046,10.151l-.017-.12a16.612,16.612,0,0,0-5.671-9.593c-4.364-3.585-10.53-4.905-15.239-7.787a3.118,3.118,0,0,0-4.775,3.033l.019.126a18.224,18.224,0,0,1,2.046.986q.567.32,1.111.679a2.716,2.716,0,0,1-1.1,4.943l-.055.009-.114.017a27.05,27.05,0,0,0,4.976,7.791c2.043,11.028,10.816,12.075,20.2,8.863h.006a66.267,66.267,0,0,0,4.452,13h15.9c.057-.177.108-.359.16-.536a18.069,18.069,0,0,1-4.4-.262c1.18-1.448,2.36-2.907,3.54-4.355a1.018,1.018,0,0,0,.074-.086c.6-.741,1.2-1.476,1.8-2.217h0a26.467,26.467,0,0,0-.776-6.742Z",
    transform: "translate(-597.179 -173.268)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M530.56,496.253h0a17.078,17.078,0,0,1-22.409-7.1L492.264,460.4l15.815-12.426,25.369,19.329a17.078,17.078,0,0,1-2.889,28.946Z",
    transform: "translate(387.432 215.915)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.235,538.156l-32.217,17.573L441.8,429.791l-8.438-110.746a57.842,57.842,0,0,1,37.017-58.422l9.495-3.63,5.858,166.94Z",
    transform: "translate(360 127.224)",
    fill: "#6c63ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawWebDesignShowcase6T2L);
export default __webpack_public_path__ + "static/media/undraw_web-design-showcase_6t2l.4c8df6d1f2199bb3bccdd1b4e695862a.svg";
export { ForwardRef as ReactComponent };